import Helpers from './../helpers/utility';
var propValuesForArgList = Helpers.propValuesForArgList;
/**
 * Augment `target` with a method for each method identified by `methods`, that defers to the
 * same method on `source`. Source can be a function, which is useful if it doesn't exist at
 * class construction time.
 *
 *
 * @param {object} target The instance to extend.
 * @param {object} source The source to compose from, or a function that returns the source
 * @param {Array} methods A list or array of methods
 */
export default function compose(target, source, methods) {
    var props;
    if (typeof source === 'function') {
        if (!methods.every(function (e) { return typeof e === 'string'; })) {
            // becuse I don't know what the props are, if it's not an instance of a thing
            throw new Error('Invalid "methods". Check that when using "compose" with a function as the source, you must specify the methods as an array of strings.');
        }
        props = methods.map(function (e) { return [e]; });
    }
    else {
        props = propValuesForArgList(source, methods);
    }
    props.forEach(function (_a) {
        var prop = _a[0], value = _a[1];
        if (typeof source === 'function') {
            target[prop] = function () {
                var invocationTarget = source.apply(this);
                return invocationTarget[prop].apply(invocationTarget, arguments);
            };
        }
        else {
            target[prop] = function () {
                return value.apply(source, arguments);
            };
        }
    });
}
//# sourceMappingURL=compose.js.map